<template>
	<main class="data-entry">
		<header class="data-entry__head">
			<p class="data-entry__eyebrow">Entrada de datos</p>
			<h2 class="data-entry__title">Archivos de la empresa</h2>
		</header>

		<ul class="data-entry__list">
			<li v-for="file in fileData" :key="file.fileType" class="file-card">
				<div class="file-card__main">
					<button
						type="button"
						class="file-card__name"
						@click="openFileModal(file.file_id, file.desc)"
					>
						{{ file.desc }}
					</button>
					<div class="file-card__meta">
						<span class="file-card__date">
							Última actualización: {{ moment(file.latest_date).format("DD-MM-YYYY") }}
						</span>
						<span
							v-if="!isLessThanMonth(file.latest_date)"
							class="file-card__badge file-card__badge--warn"
						>
							Atraso
						</span>
						<span
							v-if="!file.uploaded && isLessThanMonth(file.latest_date)"
							class="file-card__badge file-card__badge--alert"
						>
							Problema en el archivo
						</span>
					</div>
				</div>
				<div class="file-card__actions">
					<button
						type="button"
						class="btn btn--secondary"
						@click="openFileForUser(file.file_id, true)"
					>
						Solicitar
					</button>
					<button
						type="button"
						class="btn btn--primary"
						@click="openFileForUser(file.file_id, false)"
					>
						Subir
					</button>
				</div>
			</li>
		</ul>
	</main>
</template>

<script>
import { getFilesUsersByCompany } from "@/api/uploadFiles";
import CompanyUploads from "@/components/modals/CompanyUploads";
import UploadFileAsUserModal from "@/components/modals/UploadFileAsUserModal";
import moment from "moment";

export default {
	name: "CompanyInfoDataEntry",
	props: {
		basicData: {
			type: Object,
			required: true,
		},
		fileData: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			allFilesByUser: [],
			companyId: "",
			modalDefault: {
				parent: this,
				hasModalCard: true,
				width: "99%",
				height: 1000,
				customClass: "modal-class",
				canCancel: ["escape", "outside"],
				"full-screen": true,
			},
			modalDefaultUpdateSheet: {
				parent: this,
				hasModalCard: true,
				customClass: "modal-class",
				canCancel: ["escape", "outside"],
			},
		};
	},
	mounted() {
		const company_id = this.$route.query.companyId;
		this.companyId = company_id;
		getFilesUsersByCompany(company_id).then(({ data }) => {
			this.allFilesByUser = data;
		});
	},
	methods: {
		moment(date) {
			return moment(date);
		},
		isLessThanMonth(date) {
			let today = moment();
			let monthBefore = today.subtract(1, "months");
			let compareDate = moment(date);
			return monthBefore <= compareDate;
		},
		openFileModal(id, file_desc) {
			this.basicData["file_id"] = id;
			this.basicData["file_desc"] = file_desc;
			this.$buefy.modal.open({
				...this.modalDefault,
				component: CompanyUploads,
				props: {
					basicData: this.basicData,
				},
			});
		},
		openFileForUser(fileId, sendMail) {
			let allUsersByFileId = this.allFilesByUser.filter((fileUser) => {
				let fileFound = fileUser.files.filter((file) => file.id == fileId);
				return fileFound.length > 0;
			});
			this.$buefy.modal.open({
				...this.modalDefaultUpdateSheet,
				component: UploadFileAsUserModal,
				canCancel: ["escape", "button", "outside"],
				onCancel: () => this.onModalClose(),
				props: {
					fileId,
					idCompany: this.companyId,
					selectedFilesByUser: allUsersByFileId,
					sendMail,
				},
				events: {
					close: () => {
						this.onModalClose();
					},
				},
			});
		},
		onModalClose() {},
	},
};
</script>

<style scoped lang="scss">
.data-entry {
	font-family: var(--ap-font);
	color: var(--ap-ink-2);
}

.data-entry__head {
	margin-bottom: 20px;
}

.data-entry__eyebrow {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.06em;
	color: var(--ap-muted);
	margin: 0 0 4px;
}

.data-entry__title {
	font-size: 20px;
	font-weight: 600;
	color: var(--ap-ink);
	margin: 0;
}

.data-entry__list {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.file-card {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	flex-wrap: wrap;
	background: var(--ap-mist);
	border: 1px solid var(--ap-line);
	border-radius: var(--ap-radius-sm);
	padding: 16px;
	transition: border-color 0.16s var(--ap-ease);

	&:hover {
		border-color: var(--ap-line-strong);
	}
}

.file-card__main {
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-width: 0;
}

.file-card__name {
	align-self: flex-start;
	font-family: inherit;
	font-size: 15px;
	font-weight: 600;
	color: var(--ap-ink);
	background: transparent;
	border: none;
	padding: 0;
	cursor: pointer;
	text-align: left;
	transition: color 0.16s var(--ap-ease);

	&:hover {
		color: var(--ap-teal-deep);
		text-decoration: underline;
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
		border-radius: 4px;
	}
}

.file-card__meta {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
	font-size: 13px;
	color: var(--ap-slate);
}

.file-card__badge {
	display: inline-flex;
	align-items: center;
	font-size: 11px;
	font-weight: 600;
	padding: 2px 10px;
	border-radius: var(--ap-radius-pill);

	&--warn {
		color: var(--ap-warn);
		background: var(--ap-paper);
		border: 1px solid var(--ap-warn);
	}

	&--alert {
		color: var(--ap-alert);
		background: var(--ap-alert-wash);
	}
}

.file-card__actions {
	display: flex;
	gap: 8px;
	flex-shrink: 0;
}

.btn {
	font-family: inherit;
	font-size: 13px;
	font-weight: 600;
	padding: 8px 18px;
	border-radius: var(--ap-radius-pill);
	cursor: pointer;
	transition: background 0.16s var(--ap-ease), color 0.16s var(--ap-ease),
		border-color 0.16s var(--ap-ease), transform 0.16s var(--ap-ease);

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}

	&:hover {
		transform: translateY(-1px);
	}
}

.btn--primary {
	background: var(--ap-ink);
	color: var(--ap-paper);
	border: 1px solid var(--ap-ink);

	&:hover {
		background: var(--ap-teal-deep);
		border-color: var(--ap-teal-deep);
	}
}

.btn--secondary {
	background: var(--ap-paper);
	color: var(--ap-ink-2);
	border: 1px solid var(--ap-line-strong);

	&:hover {
		color: var(--ap-teal);
		border-color: var(--ap-teal);
	}
}
</style>
